import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

import {AuthenticationService} from "@shared/services/authentication/authentication.service";
import {NewNavigationService} from "@shared/services/new-navigation.service";
import {BaseComponent} from "@shared/components/base-component";

@Component({
  selector: 'am-link-login',
  templateUrl: './link-login.component.html',
  styleUrls: ['./link-login.component.less']
})
export class LinkLoginComponent extends BaseComponent implements OnInit {

  readonly url = window.location.href;

  token = '';
  isLinkNotActive = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private newNavigationService: NewNavigationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('token') as string;
    //nie da się zrobić w prosty sposób walidacji tokena na podstawie jego długości ponieważ:
    //Generowany token składa się z dwóch części: identyfikatora klienta i guida. Długość identyfikatora klienta może jest różna i przez to długość tokenu może się zmieniać.
    if (this.token)
      this.login();
  }

  private login() {
    this.authenticationService.authenticateByToken(this.token).subscribe({
      next: () =>  {
        this.newNavigationService.toMainPanelWithShareLink(this.token);
      },
      error: (err) => {
        if (err.status === 403)
          this.isLinkNotActive = true;
      }
    });
  }

}
